var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.293 2.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-12 12A1 1 0 0 1 9 22H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 .293-.707l12-12zM4 15.414V20h4.586l11-11L15 4.414l-11 11z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }